import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
function BanDuotoneGlyph(props, svgRef) {
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: [_jsx("path", { d: "M406.78 361.53a186.53 186.53 0 01-45.25 45.25L105.22 150.47a186.53 186.53 0 0145.25-45.25z", opacity: 0.4 }, void 0),
            _jsx("path", { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm130.11 378.11A184 184 0 11440 256a182.82 182.82 0 01-53.89 130.11z", className: "prefix__fa-primary" }, void 0)] }), void 0));
}
const ForwardRef = React.forwardRef(BanDuotoneGlyph);
export default ForwardRef;
